<div style="float:left; width: 100%; height: calc(100% - 100px);">
  <jqxGrid #gridTarjetas [theme]="environment.tema" [width]="'100%'" [height]="'98%'" [source]="dataAdapterTarjetas"
    [columnsresize]="true" [filterable]="true" [showfilterrow]="true" [columns]="columnsTarjetas" [sortable]="true"
    [altrows]="true" [showrowlines]="false" [filterrowheight]="30" [rowsheight]="25" [columnsheight]="25"
    [showaggregates]="true" [showstatusbar]="true" [statusbarheight]="20" [localization]="langGrid">
  </jqxGrid>
</div>
